import { getIn } from "formik";
import { FGCustomInput } from "nsitools-react";
import * as React from "react";
import PhoneInput from "react-phone-input-2";
import { Classes } from "@blueprintjs/core";
import classnames from "classnames";
import "react-phone-input-2/lib/style.css";

export interface IFGPhoneNumberInputProps {
  name: string;
  label: string;
  readonly?: boolean;
}

export const FGPhoneNumberInput: React.FunctionComponent<
  IFGPhoneNumberInputProps
> = ({ name, label, readonly = false }) => {
  return (
    <FGCustomInput label={label} name="name">
      {(ctx) =>
        ctx.editMode && !readonly ? (
          <>
            <PhoneInput
              country={"be"}
              value={getIn(ctx?.formik?.values, name)}
              onChange={(phone) => ctx.formik?.setFieldValue(name, phone)}
              containerStyle={
                ctx.formik?.errors?.[name] ? { border: "red 1px solid" } : {}
              }
              inputStyle={{ width: "100%" }}
            />
            <div
              className={classnames(
                Classes.FORM_HELPER_TEXT,
                Classes.INTENT_DANGER
              )}
              style={{ color: "#c23030" }}
            >
              {ctx.formik?.errors?.[name]}
            </div>
          </>
        ) : (
          <div>+{getIn(ctx?.formik?.values, name)}</div>
        )
      }
    </FGCustomInput>
  );
};
